import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { roomDetailsKey } from "../room-query-keys";

interface UseQueryGetRoomByIdOptions {
  refetchInterval?: number | false;
}

export function useQueryGetRoomById(roomId: string, options?: UseQueryGetRoomByIdOptions) {
  const {
    isLoading,
    data: room,
    isError,
  } = useQueryWrapper({
    queryKey: roomDetailsKey(roomId),
    queryFn: () => API.Rooms.getRoomById(roomId),
    enabled: !!roomId,
    refetchInterval: options?.refetchInterval,
  });
  return {
    room,
    isLoading,
    isError,
  };
}
